module.exports = __webpack_public_path__ + "assets/avyda-ico-pickdate.3a61e089.svg";